import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { escapeRegExp } from "lodash-es";

export function getNotificationCategoryLabel(category: string) {
  if (category === "MARKETING") {
    return "Encamp";
  }

  return prettyPrintEnumValue(category);
}

export function getNotificationProgramAreaLabel(programArea: string) {
  if (programArea === "EPCRA") {
    return "Chemicals";
  }

  if (programArea === "RCRA") {
    return "Waste";
  }

  return prettyPrintEnumValue(programArea);
}

export function getNotificationPriorityLabel(priority: string) {
  return `${prettyPrintEnumValue(priority)} priority`;
}

type SubjectDetailSource = {
  title?: string | null;
  facility?: { name?: string | null } | null;
  subject?: { label: string } | null;
};

/** Whether `text` contains `phrase` as whole words, ignoring case. */
function containsPhrase(text: string, phrase: string): boolean {
  // `\b` only knows ASCII word characters, so the boundary is spelled out in Unicode.
  return new RegExp(`(?<![\\p{L}\\p{N}])${escapeRegExp(phrase)}(?![\\p{L}\\p{N}])`, "iu").test(
    text
  );
}

/**
 * The current name of the record a notification is about, read live so a rename
 * shows. Null when the title or the facility already says it.
 */
export function getNotificationSubjectDetail(notification: SubjectDetailSource): string | null {
  const label = notification.subject?.label.trim();
  if (!label) {
    return null;
  }
  const alreadyShown = [notification.title, notification.facility?.name].some(
    (text) => text != null && containsPhrase(text, label)
  );
  return alreadyShown ? null : label;
}
